// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_r8T9j","Head":"Hero__Head_24Ksk","Title":"Hero__Title_v8dP3","Factoids":"Hero__Factoids_3SC0V"};